import React, { useState } from 'react';
import {FaBars, FaTimes} from "react-icons/fa";
import {Link} from 'react-scroll';

const Navbar = () => {
    const [nav,setNav] = useState(false);
    const links= [
        {id:1,link:'home',title:'Home'},
        {id:2,link:'about',title:'About'},
        {id:3,link:'skills',title:'Skills'},
        {id:4,link:'projects',title:'Projects'},
        {id:6,link:'contact',title:'Contact'},
        // {id:5,link:'Certifications',title:'Certifications'},
        // {id:7,link:'MyCreatives',title:'MyCreatives'}
    ];
  return (
    <div className='flex justify-between items-center w-full h-20 text-white fixed bg-black px-4'>
        <div>
            <h1 className='text-5xl font-signature ml-2'>Omkar</h1>
        </div>
        <ul className='hidden md:flex'>
            {links.map(({id,link,title})=> (
                <li 
                key = {id} 
                class="cursor-pointer px-8 font-medium text-gray-500 hover:scale-105 duration-200">
                <Link to={link} smooth duration={500}>{title}</Link>
                </li>
            ))}
        </ul>

        <div onClick={() => setNav(!nav)} className='cursor-pointer pr-4 z-10 text-gray-500 md:hidden'>
            {nav? <FaTimes size={30}></FaTimes> : <FaBars size={30}></FaBars>}
        </div>

        {nav && (
        <ul className='flex flex-col justify-center items-center absolute top-0 left-0 w-full h-screen bg-gradient-to-b from-black to-gray-800 text-gray-500 '>
        {links.map(({id,link,title})=> (
                <li 
                key = {id} 
                class="px-4 cursor-pointer capitalize py-6">
                    <Link onClick={() => setNav(!nav)} to={link} smooth duration={500}>{title}</Link>
                </li>
            ))}
        </ul>)}
    </div>
  )
}

export default Navbar;